//extracted by mini-css-extract-plugin
export default {"noRowsDiv":"CustomNoRowsTemplate_noRowsDiv__yaicJ","mainTitle":"CustomNoRowsTemplate_mainTitle__R+267","secondaryTitle":"CustomNoRowsTemplate_secondaryTitle__YwtF8"};;